// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__YZk8Z","title":"Header_title__mfytt","side":"Header_side__1vHk0"};